'use client';

import { ArrowDown } from '@/assets/icons/ArrowDown';
import { CheckIcon } from '@/assets/icons/CheckIcon';
import { useOutsideClick } from '@/hooks';
import { FiltersData } from '@/types/offerWall';
import { RefObject, useEffect, useState } from 'react';
import styles from './Select.module.scss';

interface Props {
  placeholder: string;
  handleSort: (value: null | 'amount' | 'term' | 'rate') => void;
  filtersData: FiltersData;
}

const values: Array<'Loan Amount' | 'Term' | 'Interest Rate'> = [
  'Loan Amount',
  'Term',
  'Interest Rate',
];

const Select = ({ placeholder, handleSort, filtersData }: Props) => {
  const [selectedValue, setSelectedValue] = useState<
    null | 'Loan Amount' | 'Term' | 'Interest Rate'
  >(null);
  const [isOpen, setIsOpen] = useState(false);
  const [placeholderValue, setPlaceholderValue] = useState(placeholder);

  const sortRef = useOutsideClick(() => setIsOpen(false));

  useEffect(() => {
    switch (selectedValue) {
      case 'Loan Amount':
        return handleSort('amount');
      case 'Interest Rate':
        return handleSort('rate');
      case 'Term':
        return handleSort('term');
      default:
        return handleSort(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedValue]);

  useEffect(() => {
    if (!filtersData.sortBy) {
      setSelectedValue(null);
    }
  }, [filtersData.sortBy]);

  return (
    <div
      onClick={() => setIsOpen((prev) => !prev)}
      className={`${styles.wrapper} ${isOpen ? styles.toggledWrapper : ''}`}
    >
      <div className={styles.placeholder}>
        <span
          className={`${styles.placeholderValue} ${placeholderValue !== placeholder || selectedValue ? styles.visiblePlaceholder : ''}`}
        >
          {selectedValue || placeholderValue}
        </span>
        <span
          className={`${styles.iconWrapper} ${isOpen ? styles.openIcon : ''}`}
        >
          <ArrowDown />
        </span>
      </div>
      <ul
        ref={sortRef as RefObject<HTMLUListElement>}
        className={styles.optionsWrapper}
      >
        {values.map((value) => (
          <li
            onClick={() => setSelectedValue(value)}
            className={styles.option}
            key={value}
            onMouseEnter={() => setPlaceholderValue(value)}
            onMouseLeave={() => setPlaceholderValue(placeholder)}
          >
            <span>{value}</span>
            {selectedValue === value && (
              <CheckIcon className={styles.checkIcon} />
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Select;
